export const BnLocale = {
    page: {
        txtTitle: 'SHIRITORI | মজার しらとり গেম দিয়ে অনলাইনে জাপানি শব্দভান্ডার শেখা সহজ',
    },
    common: {
        txtLogoAlt: 'Shiritori ট্রেন',
    },
    header: {
        txtLeave: 'গেম ছাড়ুন',
    },
    dialog: {
        leave: {
            txtTitle: 'এই গেমটি ছাড়বেন?',
            btnStay: 'গেমে থাকুন',
            btnLeave: 'গেম ছেড়ে হার স্বীকার করুন',
        },
    },
    home: {
        btnNewGame: 'নতুন গেম',
        btnMainMenu: 'প্রধান মেনু',
        btnJoinGame: 'যোগ দিন',
        btnReturnToGame: 'গেমে ফিরুন',
    },
    create: {
        headingNamePrompt: 'আপনাকে কী নামে ডাকব?',
        placeholderName: 'আপনার নাম',
        btnOk: 'ঠিক আছে',
    },
    join: {
        placeholderName: 'আপনার নাম',
        placeholderGameId: 'গেম আইডি',
        btnJoinGame: 'যোগ দিন',
    },
    configure: {
        header: 'গেম সেটআপ',
        labelExpectedPlayers: 'খেলোয়াড়ের সংখ্যা',
        labelBoardSize: 'বোর্ডের আকার',
        labelWordList: 'শব্দ তালিকা',
        labelAllowHints: 'ইঙ্গিতের অনুমতি দিন',
        labelTurnTimer: 'টার্ন টাইমার',
        optionNoTimer: 'টাইমার নেই',
        optionTimer: 'টাইমার',
        unitSeconds: 'সে',
        btnStartGame: 'শুরু',
        toastCreateError: 'ত্রুটি: এই গেম তৈরি করা যাচ্ছে না',
        toastTryAgain: 'ত্রুটি: পরে আবার চেষ্টা করুন।',
    },
    game: {
        lobby: {
            btnReady: 'প্রস্তুত',
            txtShareInvite: 'এই কোডটি বন্ধুদের সাথে শেয়ার করুন!',
            txtPlayer: 'খেলোয়াড়',
            txtTeam: 'দল',
        },
        message: {
            noSuchGame: 'এই গেমটি নেই',
            txtLoading: 'লোড হচ্ছে...',
            txtCannotJoin: 'গেমে যোগ দেওয়া যাচ্ছে না',
        },
        gameplay: {
            board: {
                timeoutTitle: 'সময়',
                timeoutSubtitle: 'শেষ',
            },
            wordSearch: {
                multipleMatches: 'একাধিক মিল পাওয়া গেছে!',
                yourTurn: 'আপনার পালা',
                placeholder: 'কোন শব্দ খেলব?',
                playAction: 'খেলুন',
                timerSeconds: '{{seconds}}s',
                toastNoSuchWord: 'এমন কোনো শব্দ নেই!',
                toastCantPlay: 'এই শব্দটি খেলা যাবে না!',
                toastPlayed: '"{{word}}" খেলা হয়েছে',
                toastPlayFailed: 'উফ, শব্দটি খেলা গেল না!',
                validation: {
                    syllableMismatch: 'শুরুর অক্ষরাংশ মিলছে না',
                    missingLastWord: 'শেষ টার্নে কোনো শব্দ নেই',
                    wordNotInList: 'শব্দটি নির্বাচিত তালিকায় নেই',
                }
            },
            spectate: {
                waitingOn: '{{player}}-এর জন্য অপেক্ষা',
                timeLeft: 'বাকি সময়: {{seconds}}s',
            },
            endGame: {
                header: 'গেম শেষ',
                viewResults: 'ফলাফল দেখুন',
                statsTotalTime: 'মোট খেলার সময়',
                statsSquaresFilled: 'ভরা ঘরের সংখ্যা',
                statsLongestWord: 'সবচেয়ে বড় শব্দ',
                share: 'শেয়ার',
                sharing: 'শেয়ার হচ্ছে...',
                ariaCloseLabel: 'গেম শেষের মডাল বন্ধ করুন',
            }
        },
    },
    footer: {
        linkHowToPlay: 'খেলার নিয়ম',
        linkPrivacyPolicy: 'গোপনীয়তা নীতি',
        txtAllRightsReserved: 'সর্বস্বত্ব সংরক্ষিত।',
    },
    howToPlay: {
        title: 'Shiritori しりとり (shiritori) কীভাবে খেলবেন',
        btnPlayNow: 'এখনই খেলুন!',
        btnReturnToGame: 'গেমে ফিরুন:',
        description1: 'b|Shiritori| হলো জাপানি শব্দ-চেইন গেম しりとり-এর আমাদের অনলাইন মাল্টিপ্লেয়ার সংস্করণ। বন্ধুদের সঙ্গে বা একা শব্দভান্ডার অনুশীলন করতে করতে ছবি-ভিত্তিক বোর্ড পূরণ করুন।',
        description2: 'গেম তৈরি করুন বা যোগ দিন, বোর্ডের আকার, ছবি সেট ও শব্দ তালিকা বেছে নিন, তারপর কেউ ভুল করার আগে বৈধ শব্দ দিয়ে গ্রিড পূরণের প্রতিযোগিতায় নামুন।',
        gameSetup: {
            title: 'গেম তৈরি করুন বা যোগ দিন',
            p1: 'একাই শুরু করুন অথবা শেয়ারযোগ্য লিংক/গেম কোড দিয়ে সর্বোচ্চ ৯ জন বন্ধু (মোট ১০ জন খেলোয়াড়) আমন্ত্রণ করুন।',
            p2: 'আপনার পছন্দমতো অপশন নিন: বোর্ডের আকার (3x3, 5x5, 7x7), ব্যাকগ্রাউন্ড প্যাটার্ন/রং, ছবি সেট, ও শেখার শব্দ তালিকা।',
            p3: 'বন্ধুরা লিংক খুলে ডাকনাম বেছে লবিতে যোগ দেবে; নির্ধারিত খেলোয়াড় সংখ্যা পূরণ হলেই গেম শুরু হবে।',
            p4: 'দেরিতে এলে খেলোয়াড়রা ভিউ-অনলি মোডে চলমান ম্যাচও দেখতে পারবে।',
        },
        objective: {
            title: 'উদ্দেশ্য',
            p1: 'শব্দ এমনভাবে জুড়ুন যাতে নতুন শব্দটি আগের শব্দের শেষ অক্ষরাংশ দিয়ে শুরু হয়, বোর্ড পূর্ণ করুন, এবং কোনো শব্দ ん দিয়ে শেষ করবেন না।',
        },
        wordRules: {
            title: 'বৈধ শব্দ',
            p1: 'কানা বা রোমাজি দিয়ে টাইপ করুন; যাচাইয়ের আগে ক্লায়েন্টে রোমাজি হিরাগানায় রূপান্তরিত হয়।',
            p2: 'শব্দ অবশ্যই নির্বাচিত তালিকায় থাকতে হবে (সাধারণ 100/1000, খাবার, খেলাধুলা ইত্যাদি) এবং খেলার পরে অর্থ দেখাবে।',
            p3: 'আগে ব্যবহৃত শব্দ ব্লক করা হয়। Homophone অনুমোদিত থাকলে সঠিক ছবিসহ অব্যবহৃত ভ্যারিয়েন্ট বেছে নিতে পারবেন।',
            li1: 'আগের টার্নে নির্ধারিত অক্ষরাংশ দিয়ে শুরু হতে হবে',
            li2: 'ん (n) দিয়ে শেষ হওয়া যাবে না',
            li3: 'নির্বাচিত শব্দ তালিকায় থাকতে হবে',
            li4: 'এই ম্যাচে আগে খেলা হয়নি',
            li5: 'নিয়ম চালু থাকলে অনুমোদিত homophone/ছবি ব্যবহার করতে হবে',
            p4: 'প্রতি বৈধ চাল তার ছবি ক্রমানুসারে বোর্ডে বসায়, বাম থেকে ডানে ও উপর থেকে নিচে গ্রিড পূরণ করে। e|উদাহরণ:_そば_→_バス|',
        },
        turnFlow: {
            title: 'টার্ন ও সময়',
            p1: 'টার্ন খেলোয়াড় তালিকা ধরে ঘুরে আসে; আপনার পালা দেখার মুহূর্ত থেকে সর্বোচ্চ ১০ সেকেন্ড সময় পাবেন।',
            p2: 'Shiritori পরের খেলোয়াড় সক্রিয় (ব্রাউজার ফোকাসে) না হওয়া পর্যন্ত কাউন্টডাউন শুরু করে না, তাই রিস্টার্ট/রিলোড করে টাইমার এড়ানো যায় না।',
            p3: 'শব্দ লিখুন, লাইভ ভ্যালিডেশন দেখুন, এবং সময়সীমার আগে জমা দিন। অবৈধ বা দেরি সাবমিশন হলে ম্যাচ সাথে সাথেই শেষ হয়।',
        },
        boardFlow: {
            title: 'বোর্ড, প্রবাহ ও সমাপ্তি',
            p1: 'বোর্ডে প্রতিটি খেলা শব্দের ছবি, খেলোয়াড়ের নাম ও টার্ন নম্বর দেখায়; তীরচিহ্ন গ্রিডে ক্রম দেখায়।',
            p2: 'অন্য কারও পালা হলেও প্রয়োজনীয় শুরুর অক্ষরাংশ ও কাউন্টডাউন দেখতে পারবেন।',
            p3: 'সব ঘর বৈধ শব্দে পূর্ণ হলে গেম সফলভাবে শেষ হবে এবং শেয়ারের জন্য সম্পূর্ণ বোর্ড দেখাবে।',
            p4: 'সময় শেষ হওয়ার আগে কোনো বৈধ চাল না এলে গেম শেষ হবে এবং কার সময় ফুরিয়েছে বা কে অবৈধ শব্দ দিয়েছে তার সারাংশ দেখাবে।',
        },
        summary: {
            title: 'সারাংশ',
            p1: 'Shiritori shiritori-কে দ্রুত ও ভিজ্যুয়াল রাখে: ছোট রাউন্ড, পরিষ্কার নিয়ম, আর ছবিভিত্তিক মনে রাখার কৌশল সবার শব্দ-চেইন টিকিয়ে রাখতে সাহায্য করে।',
            p2: 'একটি লিংক শেয়ার করুন, বোর্ড পূরণ করুন, আর দেখুন আপনার শব্দ-চেইন কতদূর যেতে পারে।',
        }
    },
    bugsAndFeatures: {
        title: 'বাগ রিপোর্ট ও নতুন ফিচার',
        p1: 'আমরা এই গেমটি ক্লাসিক k|しりとり.| খেলার একটি ভিন্ন উপায় হিসেবে তৈরি করেছি। গেমপ্রেমী দল হিসেবে আমরা সব সময় এটিকে আরও ভালো ও আনন্দদায়ক করার পথ খুঁজি।',
        cta: {
            l1: 'আসলে, আপনি যদি ',
            a: 'আপনার বন্ধুদের সাথে আমাদের গেমটি শেয়ার করে',
            l2: ' সোশ্যাল মিডিয়ায় সাহায্য করেন, আমরা খুব খুশি হব!'
        },
        p2: 'কোনো বাগ দেখলে বা নতুন ফিচারের প্রস্তাব থাকলে আমাদের জানান!',
        bugs: {
            title: 'বাগ',
            p1: 'অস্বাভাবিক আচরণ, ত্রুটি বা বাগ সরাসরি আমাদের পাবলিক a|https://github.com/indexinteractive/|GitHub_রিপোজিটরিতে| রিপোর্ট করুন। বাগ পুনরায় তৈরি করার ধাপসহ যত বেশি সম্ভব বিস্তারিত দিন।'
        },
        features: {
            title: 'নতুন ফিচার',
            p1: 'নতুন ফিচার, উন্নতি, বা গেম আইডিয়া থাকলে আমাদের a|https://github.com/indexinteractive/|GitHub_Discussions| পেজে নতুন আলোচনা খুলে জানান।'
        }
    },
    share: {
        title: 'Shiritori | মজার しらとり গেম দিয়ে অনলাইনে জাপানি শব্দভান্ডার শেখা সহজ - SHIRITORI',
        text: 'বন্ধু বা যেকোনো খেলোয়াড়ের সাথে অনলাইনে Shiritori খেলুন। সাইন-আপ লাগবে না!',
    }
};
